export const init = () => {
  if (document.querySelector('#PersoLVPFloor')) {
    CUBE.Analytics.enhanced.plv2.es6.initImpression('#PersoLVPFloor', 'lvp');
  } else { //TODO : remove when LVP will be generated in a better way (like in product page)
    CUBE.Analytics.enhanced.plv2.es6.initImpression('.list-last-viewed-products .pl-list.product-list-v2', 'lvp');
  }
};



// WEBPACK FOOTER //
// ./src/analytics/enhanced/ec-impression-lvp.js